"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Component for Metaform slider field
 */
class MetaformSliderFieldComponent extends react_1.default.Component {
    /**
     * Component render method
     */
    render() {
        const { field, renderSlider, formReadOnly } = this.props;
        if (!field.name || !renderSlider) {
            return null;
        }
        const readOnly = !!(formReadOnly || field.readonly);
        return renderSlider(field.name, readOnly);
    }
}
exports.MetaformSliderFieldComponent = MetaformSliderFieldComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1TbGlkZXJGaWVsZENvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9NZXRhZm9ybVNsaWRlckZpZWxkQ29tcG9uZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLGtEQUEwQjtBQTBCMUI7O0dBRUc7QUFDSCxNQUFhLDRCQUE2QixTQUFRLGVBQUssQ0FBQyxTQUF1QjtJQUU3RTs7T0FFRztJQUNJLE1BQU07UUFDWCxNQUFNLEVBQUUsS0FBSyxFQUFFLFlBQVksRUFBRSxZQUFZLEVBQUUsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDO1FBRXpELElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxJQUFJLENBQUMsWUFBWSxFQUFFO1lBQ2hDLE9BQU8sSUFBSSxDQUFDO1NBQ2I7UUFFRCxNQUFNLFFBQVEsR0FBRyxDQUFDLENBQUMsQ0FBQyxZQUFZLElBQUksS0FBSyxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQ3BELE9BQU8sWUFBWSxDQUFDLEtBQUssQ0FBQyxJQUFJLEVBQUUsUUFBUSxDQUFDLENBQUM7SUFDNUMsQ0FBQztDQUVGO0FBaEJELG9FQWdCQyJ9